





























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import _ from 'lodash';    


@Component
export default class CollectionCodeTracking extends AbpBase{
    namespace = 'report';
    keyword:string='';
    trackinglist=[];
    get store(){
        return this.$store.state.report;
    }
   get list(){
      var re = this.trackinglist;
      var startIndex = 1;
      re.forEach(function(item) {
        item.orderNo = startIndex ;
        startIndex++;
      });
      return re;
    }
    get loading()
    {
        return this.store.loading;
    }
    async getPage()
    {
        if(Util.isNull(this.keyword))
            return;
        
        this.trackinglist = await this.$store.dispatch({
            type: `${this.namespace}/getCollectionCodeTracking`,
            data: {
                keyword: this.keyword}
        })
    }
   
    columns = [
            {
                 title: Util.L('Order'),
                key: 'orderNo',
                width: 70
            },
             {
                title: Util.L('Content'),
                key: 'creationTime',
                 render: (h, params) => {
                    return h("span",`${params.row.actionTypeName} [${params.row.externalCode}] đối tác ${params.row.clientName} : ${params.row.warehouseName} - ${Util.toViewShortTimeDateString (params.row.creationTime)}`) 
                }
            }
    ]
}
